import { useMemo } from "react"

import { useFetchCurrentUser } from "@/hooks/api/users"

import { useEmailIntegrations } from "./queries"

export function useEmailIntegrationAccess() {
  const { data: ownedEmailIntegrations, isLoading: isLoadingOwnedEmailIntegrations } = useEmailIntegrations()
  const { data: currentUser, isLoading: isLoadingCurrentUser } = useFetchCurrentUser({ staleTime: 0 })

  const hasOwnedEmailIntegration = Boolean(ownedEmailIntegrations?.length)
  const hasAccessibleEmailIntegration = Boolean(currentUser?.accessible_email_integrations?.length)
  const hasEmailIntegrationAccess = hasOwnedEmailIntegration || hasAccessibleEmailIntegration

  // While resolving access, avoid flashing the "Connect your email" state.
  const isLoadingAccess = !hasEmailIntegrationAccess && (isLoadingOwnedEmailIntegrations || isLoadingCurrentUser)

  const accessibleEmailIntegrations = useMemo(
    () => currentUser?.accessible_email_integrations ?? ownedEmailIntegrations ?? [],
    [currentUser?.accessible_email_integrations, ownedEmailIntegrations]
  )

  return {
    accessibleEmailIntegrations,
    hasEmailIntegrationAccess,
    isLoadingAccess,
  }
}
